'use client';

import Link from '@eliadmin/core/src/components/link';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { MdKeyboardArrowDown } from 'react-icons/md';

export function HeroScrollLink() {
  const { t } = useTranslations();

  return (
    <Link
      prefetch={false}
      href={'#preco-my'}
      className="hidden cursor-pointer items-center gap-4 transition-all hover:opacity-85 lg:flex"
    >
      <div className="flex h-12 w-12 items-center justify-center border border-white/30 lg:h-14 lg:w-14">
        <MdKeyboardArrowDown size={24} className="text-white" />
      </div>
      <p className="text-base text-white/50">{t('text2404')}</p>
    </Link>
  );
}
